//import { DecodeHTMLEntities } from '../../../utils/decodehtmlentities';
import { ChildListTonesDto, ChildListTonesDtoImpl } from './childlisttonesdto';
import { GroupDtoImpl } from './groupdto';
import { BaseContext } from '../../../utils/basecontext';
import { Strings } from '../../../utils/resources/strings';
import { MemberDetailsDtoImpl, MemberDetailsDto } from './memberdetailsdto';
import { DateFormat } from '../../../ui/toolkit/dateformat/dateformat';
import { ToneStatus } from '../../../ui/toolkit/toneoptions/tone/tonestatus';
//import { NoDataException } from '../../../utils/exceptions/nodataexistsexception';

export class ListTonesBuilder {
    constructor(private listTones: any, private context: BaseContext) {

        /* if(listTones.listToneApk.toneDetails === undefined)
        {
            throw new NoDataException("Get Banner data doesnt exists");
        } */
    }

    buildAll(): ChildListTonesDto[] {
        return this.parseListTonesResponse();
    }

    private parseListTonesResponse(): ChildListTonesDto[] {
        let listOfListTones: ChildListTonesDto[] = [];
        let childListTonesDto: ChildListTonesDtoImpl;
        let groupDto: GroupDtoImpl;

        this.listTones.listToneApk.forEach((listToneApkItem: any , index:any ) => {
            console.log("--tigerbuilder"+listToneApkItem.serviceName);

            if (listToneApkItem.toneDetails !== undefined) {

                listToneApkItem.toneDetails.forEach((toneItem: any) => 
                {
                    // console.log("-----shuffle in listtonebuilder "+toneItem.isShuffle);
                    childListTonesDto = new ChildListTonesDtoImpl();
                    childListTonesDto.setId(toneItem.toneId);
                    childListTonesDto.setToneName(toneItem.toneName);
                    childListTonesDto.setToneUrl(toneItem.toneIdStreamingUrl);
                    childListTonesDto.setImgPath(toneItem.toneIdpreviewImageUrl);
                    childListTonesDto.setAlbumName(toneItem.albumName);
                    childListTonesDto.setArtistName(toneItem.artistName);
                    childListTonesDto.setPrice(toneItem.price);
                    childListTonesDto.setStatus(this.getStatus(toneItem.status));
                    childListTonesDto.setCreatedDate(toneItem.createdDate);
                    // childListTonesDto.setIsShuffle(toneItem.isShuffle);
                 
                    childListTonesDto.setCallerStatus(toneItem.status);
                    childListTonesDto.setEndTime(toneItem.endTime);
                    childListTonesDto.setStartTime(toneItem.startTime);
                    childListTonesDto.setEndDayMonthly(toneItem.endDayMonthly);
                    childListTonesDto.setEndTimeMonthly(toneItem.endTimeMonthly);
                    childListTonesDto.setStartDayMonthly(toneItem.startDayMonthly);
                    childListTonesDto.setStartTimeMonthly(toneItem.startTimeMonthly);
                    childListTonesDto.setEndTimeWeekly(toneItem.endTimeWeekly);
                    childListTonesDto.setStartTimeWeekly(toneItem.startTimeWeekly);
                    childListTonesDto.setWeeklyDays(toneItem.weeklyDays);
                    childListTonesDto.setCustomiseEndDate(toneItem.customiseEndDate);
                    childListTonesDto.setCustomiseEndTime(toneItem.customiseEndTime);
                    childListTonesDto.setCustomiseStartDate(toneItem.customiseStartDate);
                    childListTonesDto.setCustomiseStartTime(toneItem.customiseStartTime);
                    childListTonesDto.setYearlyEndDay(toneItem.yearlyEndDay);
                    childListTonesDto.setYearlyEndMonth(toneItem.yearlyEndMonth);
                    childListTonesDto.setYearlyEndTime(toneItem.yearlyEndTime);
                    childListTonesDto.setYearlyStartDay(toneItem.yearlyStartDay);
                    childListTonesDto.setYearlyStartMonth(toneItem.yearlyStartMonth);
                    childListTonesDto.setYearlyStartTime(toneItem.yearlyStartTime);
                    childListTonesDto.setServiceName(listToneApkItem.serviceName);
                    childListTonesDto.setExpirydate(DateFormat.formatExpiryDate(listToneApkItem.expiryDate, this.context));

                    if(toneItem.isShuffle !== undefined && toneItem.isShuffle === "T")
                    {
                        console.log("-----shuffle in listtonebuilder "+toneItem.isShuffle);

                        childListTonesDto.setIsShuffle("T");

                    }
                    else
                    {
                        childListTonesDto.setIsShuffle("F");

                    }

                    if(toneItem.isStatusRbt !== undefined && toneItem.isStatusRbt === "T")
                    {
                        childListTonesDto.setIsStatusRBT(true);
                    }
                    if(childListTonesDto.getServiceName() === this.context.getResources().getString(Strings.specialCallerSetting))
                    {
                        childListTonesDto.setMsisdnB(listToneApkItem.msisdnB);
                    }

                    if(listToneApkItem.groupId !== 0)
                    {
                        // msisdnB = "091222222777|Dummy,091222222999|Dummy2,091222222888|Dummy3";
                        let memberDetailsDto : MemberDetailsDtoImpl ;
                        let listOfMemberDetails: MemberDetailsDto[] = [];

                        let listOfMsisdnAndMemberName : string[] = [];
                        listOfMsisdnAndMemberName = listToneApkItem.msisdnB.split(",");
                        listOfMsisdnAndMemberName.forEach((msisdnAndMemberNameItem: any) => {
                            memberDetailsDto = new MemberDetailsDtoImpl();
                            memberDetailsDto.setMsisdn(msisdnAndMemberNameItem.split("|")[0]);
                            memberDetailsDto.setMemberName(msisdnAndMemberNameItem.split("|")[1]);

                            listOfMemberDetails.push(memberDetailsDto);
                        });
                        
                        groupDto = new GroupDtoImpl();
                        groupDto.setMembersList(listOfMemberDetails);
                        groupDto.setServiceName(listToneApkItem.serviceName);
                        groupDto.setMsisdnB(listToneApkItem.msisdnB);
                        groupDto.setGroupId(listToneApkItem.groupId);
                        groupDto.setGroupName(listToneApkItem.groupName);
                        groupDto.setGroupDesc(listToneApkItem.groupDesc);
                        groupDto.setIsBlocked(listToneApkItem.isBlocked);
                        groupDto.setId(index);
                        childListTonesDto.setGroupDto(groupDto);
                    }
                    listOfListTones.push(childListTonesDto);
                });
            }
            else if(listToneApkItem.groupId !== 0)
            {
                // msisdnB = "091222222777|Dummy,091222222999|Dummy2,091222222888|Dummy3";
                 let memberDetailsDto : MemberDetailsDtoImpl ;
                let listOfMemberDetails: MemberDetailsDto[] = [];

                let listOfMsisdnAndMemberName : string[] = [];
                listOfMsisdnAndMemberName = listToneApkItem.msisdnB.split(",");
                listOfMsisdnAndMemberName.forEach((msisdnAndMemberNameItem: any) => {
                    memberDetailsDto = new MemberDetailsDtoImpl();
                    memberDetailsDto.setMsisdn(msisdnAndMemberNameItem.split("|")[0]);
                    memberDetailsDto.setMemberName(msisdnAndMemberNameItem.split("|")[1]);
                            
                    listOfMemberDetails.push(memberDetailsDto);
                });
                
                childListTonesDto = new ChildListTonesDtoImpl();
                groupDto = new GroupDtoImpl();
                groupDto.setMembersList(listOfMemberDetails);
                groupDto.setServiceName(listToneApkItem.serviceName);
                groupDto.setMsisdnB(listToneApkItem.msisdnB);
                groupDto.setGroupId(listToneApkItem.groupId);
                groupDto.setGroupName(listToneApkItem.groupName);
                groupDto.setGroupDesc(listToneApkItem.groupDesc);
                groupDto.setIsBlocked(listToneApkItem.isBlocked);
                groupDto.setId(index);
                childListTonesDto.setGroupDto(groupDto);
                listOfListTones.push(childListTonesDto);
            }
        });
        return listOfListTones;
    }
    private getStatus(status: string)
    {
        if(status === "P")
        {
            return ToneStatus.PENDING;
        }
        else if(status === "R")
        {
            return ToneStatus.REJECTED;
        }
        else if(status === "IA")
        {
            return ToneStatus.INACTIVE;
        }
        else if(status === "G")
        {
            return ToneStatus.INACTIVE;
        }
        else if(status === "A")
        {
            return ToneStatus.ACCEPTED;
        }
        else{
            return ToneStatus.INACTIVE;
        }
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/listtones/listtonesbuilder.ts